import React from 'react';
import 'i18n';
// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// Bootstrap Bundle JS
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';
// import Modal from 'components/modal';
import reportWebVitals from './reportWebVitals';

import 'bootstrap-icons/font/bootstrap-icons.css';

import 'devextreme/dist/css/dx.light.css';
import 'assets/scss/index.scss';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<BrowserRouter basename={process.env.REACT_APP_BASENAME}>
		<Provider store={store}>
			<App />
			{/* <Modal /> */}
		</Provider>
	</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
